webpackJsonp([33],{

/***/ 506:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _message = __webpack_require__(58);

var _message2 = _interopRequireDefault(_message);

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(59);

__webpack_require__(317);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _utils = __webpack_require__(24);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LoginPassword = function (_React$Component) {
  _inherits(LoginPassword, _React$Component);

  function LoginPassword() {
    _classCallCheck(this, LoginPassword);

    var _this = _possibleConstructorReturn(this, (LoginPassword.__proto__ || Object.getPrototypeOf(LoginPassword)).call(this));

    _this.state = {
      mobile: '',
      password: ''
    };
    return _this;
  }

  _createClass(LoginPassword, [{
    key: 'handleTextChange',
    value: function handleTextChange(key, value) {
      this.setState(_defineProperty({}, key, value));
    }
  }, {
    key: 'login',
    value: function login() {
      var login = this.props.login;
      var _state = this.state,
          mobile = _state.mobile,
          password = _state.password;

      if (!(0, _utils.checkMobile)(mobile)) {
        return;
      }
      if (!password.trim()) {
        _message2.default.warn('请输入密码');
        return;
      }
      login(this.state);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      return _react2.default.createElement(
        'div',
        { className: 'loginPassword' },
        _react2.default.createElement(
          'div',
          { className: 'loginPassword-phone' },
          _react2.default.createElement('input', { type: 'text', placeholder: '\u8BF7\u8F93\u5165\u624B\u673A\u53F7', onChange: function onChange(e) {
              return _this2.handleTextChange('mobile', e.target.value);
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'loginPassword-password' },
          _react2.default.createElement('input', { type: 'password', placeholder: '\u8BF7\u8F93\u5165\u5BC6\u7801', onChange: function onChange(e) {
              return _this2.handleTextChange('password', e.target.value);
            } })
        ),
        _react2.default.createElement(
          'div',
          { className: 'loginPassword-btn', onClick: function onClick() {
              return _this2.login();
            } },
          '\u767B\u5F55'
        )
      );
    }
  }]);

  return LoginPassword;
}(_react2.default.Component);

exports.default = LoginPassword;

/***/ })

});


// WEBPACK FOOTER //
// static/js/33.b1bf51b7.chunk.js